var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hasValue && _vm.visible)?_c('label-value',{attrs:{"label":_vm.label}},[_c('document-field',{attrs:{"document":_vm.document,"field":_vm.field,"unit":_vm.unit || _vm.field.unit,"divisor":_vm.divisor,"prefix":_vm.prefix,"sort-values":_vm.sortValues}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }